import { Clock, MapPin } from "lucide-react";
import Reveal from "@/components/Reveal";
import SectionTag from "@/components/SectionTag";
import { BookButton, CallButton, EmergencyNote } from "@/components/CTA";
import { SITE } from "@/data/site";

export default function LocationCTA() {
  return (
    <section data-testid="location-section" className="bg-white">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 py-20 sm:px-6 md:py-28 lg:grid-cols-12 lg:px-12">
        <div className="lg:col-span-5">
          <Reveal>
            <SectionTag number="06" label="Visit Us" />
            <h2 className="mt-5 font-display text-2xl font-bold tracking-tight text-brand-navy sm:text-3xl lg:text-4xl">
              Right here in{" "}
              <span className="font-serif italic text-brand-red">Prescott Valley</span>
            </h2>
            <ul className="mt-8 space-y-5">
              <li className="flex gap-3.5" data-testid="location-address">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-brand-redlight">
                  <MapPin className="h-5 w-5 text-brand-red" />
                </span>
                <div>
                  <p className="text-sm font-semibold text-brand-navy">{SITE.addressShort}</p>
                  <p className="text-sm text-slate-500">{SITE.city}</p>
                </div>
              </li>
              <li className="flex gap-3.5" data-testid="location-hours">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-brand-redlight">
                  <Clock className="h-5 w-5 text-brand-red" />
                </span>
                <div>
                  <p className="text-sm font-semibold text-brand-navy">{SITE.hours}</p>
                  <p className="text-sm text-slate-500">{SITE.hoursNote}</p>
                </div>
              </li>
            </ul>
            <p className="mt-6 max-w-md text-sm leading-relaxed text-slate-500">
              Proudly serving{" "}
              {SITE.serviceAreas.slice(0, -1).join(", ")}, and{" "}
              {SITE.serviceAreas[SITE.serviceAreas.length - 1]}.
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <BookButton testid="location-book-online-btn" />
              <CallButton testid="location-call-btn" label="Call for Same-Day Care" />
            </div>
            <EmergencyNote testid="location-emergency-note" className="mt-5 max-w-md" />
          </Reveal>
        </div>
        <div className="lg:col-span-7">
          <Reveal delay={0.15}>
            <div className="overflow-hidden rounded-[2rem] border border-slate-100 shadow-lift">
              <iframe
                title="Map to Advantage Primary Health, Prescott Valley, AZ"
                data-testid="location-map"
                src={SITE.mapEmbed}
                className="h-[380px] w-full lg:h-[460px]"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
